
// Runs a CcApis3 function. Any calls should be made through this intermediary so that failures can be intercepted
// for failover handling.

export const callCcApi = async (fn, args, {logFailoverIncident, onNotifyFailover, getCcHost, ccHost, ccVersion, attemptNumber = 1}) => {

    // run the function and return if the value isn't null - null will be returned in cases of errors due to the
    // nullException wrapper being used in CcApis3 - this assumes no services ever need to return null as a
    // legitimate response
    const response = await fn(args);
    if (response !== null) return response;

    // FAILOVER ACTIONS

    // check for next available host
    const failoverHostData = await getCcHost().catch(err => null); // return null if can't reach host service

    // if no host found, let the user know there was an error
    if (!failoverHostData?.ccHost) {
        logFailoverIncident({});
        onNotifyFailover(failoverHostData !== null, false, false);
        return null;
    }

    // log the incident
    logFailoverIncident({retryHost: failoverHostData.ccHost});

    // if same host was found, then momentary issue - retry the original call and continue as normal
    if (failoverHostData.ccHost === ccHost && attemptNumber++ < 3) return callCcApi(fn, args, {logFailoverIncident, onNotifyFailover, getCcHost, ccHost, ccVersion, attemptNumber});

    onNotifyFailover(true, true, false);

}